import React from 'react'
import PropTypes from 'prop-types'
import { CATEGORY_TYPES, CATEGORY_TYPES_KEYS, CATEGORY_THEMES } from 'LiveBoard/config/constants'
import { getCategoryStyle, getArrowCSS } from './helper'
import { ParentCategory, Category, LinkCategory } from './types'
import { HOME_CATEGORY } from 'LiveBoard/modules/itemsView'
import { ScrollableTabs } from 'shared/UI/ScrollableTabs'
import pick from 'lodash/pick'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

const CATEGORY_COMPONENTS = {
  [CATEGORY_TYPES.category]: Category,
  [CATEGORY_TYPES.parentCategory]: ParentCategory,
  [CATEGORY_TYPES.subcategory]: Category,
  [CATEGORY_TYPES.linkCategory]: LinkCategory
}

const CategoriesRenderer = (props) => {
  const {
    themeColorHex, categoryTheme, categories, categoryIds,
    selectedCategoryId, showHomeCategory, onSelect, board, autoClose
  } = props

  const css = {
    categoriesRenderer: getCategoryStyle(themeColorHex, categoryTheme ,"categoriesRenderer"),
    category: getCategoryStyle(themeColorHex, categoryTheme ,"category"),
    arrow: getArrowCSS(themeColorHex)
  }

  const isScrollable = (categoryTheme === CATEGORY_THEMES.tab)

  const getSelectedCategoryIndex =  () => {
    // in case selectedCategoryId is not a number ('search', 'home'), return index = 0
    if (isNaN(selectedCategoryId)) {
      return 0
    }

    const selectedCategory = get(categories, selectedCategoryId, {})
    const mainCategoryId = selectedCategory.parent_category_id ?
      selectedCategory.parent_category_id : selectedCategoryId

    let selectedIndex = categoryIds.indexOf(mainCategoryId)
    return showHomeCategory ? selectedIndex + 1 : selectedIndex
  }

  const categoryRendererComponent = (
    <div style={css.categoriesRenderer} className="categories-renderer">
      { showHomeCategory && (
        <Category
          board={board}
          category={HOME_CATEGORY}
          selectedCategoryId={selectedCategoryId}
          onSelect={onSelect}
          categoryCSS={css.category}
          autoClose={autoClose}
          categoryTheme={categoryTheme}
        />
      )}
      {
        categoryIds.map((categoryId) => {
          const category = categories[categoryId]

          if (!category) {
            return null
          }

          const subCategories = pick(categories, category.subcategories_ids)
          const SpecificComponent = CATEGORY_COMPONENTS[category.category_type]
          const categoryCSS = getCategoryStyle(themeColorHex, categoryTheme ,CATEGORY_TYPES_KEYS[category.category_type])
          const subCategoryCSS = getCategoryStyle(themeColorHex, categoryTheme ,'subcategory')

          return (
            <SpecificComponent
              key={categoryId}
              board={board}
              category={category}
              categoryTheme={categoryTheme}
              subCategories={subCategories}
              subCategoryCSS={subCategoryCSS}
              selectedCategoryId={selectedCategoryId}
              categoryCSS={categoryCSS}
              onSelect={onSelect}
              autoClose={autoClose} />
          )
        })
      }
    </div>
  )

  return !isEmpty(categoryIds) && (
    <div className="wrapper">
      {isScrollable ? (
        <ScrollableTabs
          selectedElementIndex={getSelectedCategoryIndex()}
          padding={12}
          arrowStyle={css.arrow}>
          {categoryRendererComponent}
        </ScrollableTabs>
      ) : categoryRendererComponent
      }
    </div>
  )
}

CategoriesRenderer.propTypes = {
  board: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string,
  categoryIds: PropTypes.array.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onSelect: PropTypes.func.isRequired,
  categoryClass: PropTypes.string,
  selectedCategoryCSS: PropTypes.object,
  autoClose: PropTypes.bool.isRequired,
  showHomeCategory: PropTypes.bool
}

CategoriesRenderer.defaultProps = {
  categoryClass: "",
  autoClose: false
}

export default CategoriesRenderer
